(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fcp-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fcp-hero-carousel')) {
    class FcpHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.fcp-hero__track');
        this.slides = Array.from(this.querySelectorAll('.fcp-hero__slide'));
        if (this.slides.length < 2) {
          return;
        }
        this.dots = Array.from(this.querySelectorAll('.fcp-hero__dot'));
        this.toggle = this.querySelector('.fcp-hero__toggle');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.delay = Number(this.dataset.autoplay) * 1000;
        this.querySelector('.fcp-hero__prev').addEventListener('click', () => {
          this.stop();
          this.go(this.index - 1);
        });
        this.querySelector('.fcp-hero__next').addEventListener('click', () => {
          this.stop();
          this.go(this.index + 1);
        });
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.stop();
            this.go(i);
          });
        });
        if (this.toggle) {
          this.toggle.addEventListener('click', () => {
            if (this.playing) {
              this.stop();
            } else {
              this.play();
            }
          });
        }
        this.track.addEventListener(
          'scroll',
          () => {
            window.clearTimeout(this.settle);
            this.settle = window.setTimeout(() => {
              this.sync();
            }, 120);
          },
          { passive: true }
        );
        this.addEventListener('mouseenter', () => {
          this.hover = true;
        });
        this.addEventListener('mouseleave', () => {
          this.hover = false;
        });
        this.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target.closest('.fcp-hero__slide'));
          if (i >= 0) {
            this.stop();
            this.go(i);
          }
        });
        if (this.delay > 0 && !this.reduce.matches) {
          this.play();
        } else {
          this.render();
        }
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
      }
      play() {
        this.playing = true;
        window.clearInterval(this.timer);
        this.timer = window.setInterval(() => {
          if (!this.hover && !this.contains(document.activeElement) && !document.hidden) {
            this.go(this.index + 1);
          }
        }, this.delay);
        this.render();
      }
      stop() {
        this.playing = false;
        window.clearInterval(this.timer);
        this.render();
      }
      go(i) {
        const count = this.slides.length;
        this.index = (i + count) % count;
        this.track.scrollTo({
          left: this.index * this.track.clientWidth,
          behavior: this.reduce.matches ? 'auto' : 'smooth',
        });
        this.render();
      }
      sync() {
        const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (i !== this.index) {
          this.index = i;
          this.render();
        }
      }
      render() {
        this.toggleAttribute('data-playing', Boolean(this.playing));
        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });
        this.slides.forEach((slide, i) => {
          slide.toggleAttribute('inert', i !== this.index);
        });
        if (this.toggle) {
          this.toggle.setAttribute('aria-label', this.playing ? 'Pause slideshow' : 'Play slideshow');
        }
      }
    }
    customElements.define('fcp-hero-carousel', FcpHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
